import { z } from 'zod'

export const SLUG_MAX_LENGTH = 64
export const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/

export const Slug = z
  .string()
  .min(1, 'Slug is required')
  .max(SLUG_MAX_LENGTH, `Slug must be at most ${SLUG_MAX_LENGTH} characters`)
  .regex(slugPattern, 'Slug may only contain lowercase letters, numbers, and hyphens')

/** Top-level app paths a show address must not take: public pages and My Account. */
export const RESERVED_SHOW_SLUGS = ['public', 'account'] as const
export const ShowSlug = Slug.refine(value => !isReservedShowSlug(value), 'This slug is reserved')
export function isReservedShowSlug(value: string): boolean {
  return RESERVED_SHOW_SLUGS.some(slug => slug === value.trim().toLowerCase())
}

export type TShowSlug = z.infer<typeof ShowSlug>

const COMBINING_MARKS = /[\u0300-\u036f]/g
const INVALID_CHARACTERS = /[^a-z0-9\s-]/g

export function slugify(value: string): string {
  const normalized = value.normalize('NFKD').replace(COMBINING_MARKS, '').toLowerCase()
  const sanitized = normalized.replace(INVALID_CHARACTERS, ' ').replace(/_/g, ' ')
  const collapsed = sanitized.trim().replace(/[\s-]+/g, '-')
  const truncated = collapsed.slice(0, SLUG_MAX_LENGTH)
  return truncated.replace(/^-+|-+$/g, '')
}

export function isValidSlug(slug: string): boolean {
  const trimmed = slug.trim()
  if (trimmed.length === 0 || trimmed.length > SLUG_MAX_LENGTH) {
    return false
  }
  return slugPattern.test(trimmed) && !isReservedShowSlug(trimmed)
}
